/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Name = 'Website.MyProfile.FrontPage.Subscription.Name';
export const NextDelivery = 'Website.MyProfile.FrontPage.Subscription.NextDelivery';
